import editorVisibilityHandler from './editor-visibility-handler';

export default {
  editorVisibilityHandler,
};
